"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * @file Created on Wed Apr 24 2019
 */

var WindowSimulation_1 = require("./WindowSimulation");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");

var Window_1 = require("./Window");
/**
 * Used to update {@link Window}
 *
 * @author BPo
 */


var WindowUpdateDTO =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(WindowUpdateDTO, _DomainObject_1$Domai);

  /**
   * Creates new DTO for {@link Window} update
   * @param {Window} document
   * @param {WindowSimulation} simulation Accepted or rejected window simulations
   * @memberof WindowUpdateDTO
   */
  function WindowUpdateDTO(document, simulation) {
    var _this;

    _classCallCheck(this, WindowUpdateDTO);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WindowUpdateDTO).call(this));
    _this.document = document;
    _this.simulation = simulation;
    return _this;
  }

  return WindowUpdateDTO;
}(DomainObject_1.DomainObject);

exports.WindowUpdateDTO = WindowUpdateDTO;

WindowUpdateDTO.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(WindowUpdateDTO.name);
  return {
    document: builder.obj('document', Window_1.Window.schema, function (mat) {
      return Window_1.Window.fromDataDict(mat);
    }),
    simulation: builder.opt(builder.obj('simulation', WindowSimulation_1.WindowSimulation.schema, function (mat) {
      return WindowSimulation_1.WindowSimulation.fromDataDict(mat);
    }))
  };
}();